import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import CadminApi  from 'app/apis/company-admin';
import DatePicker from 'app/components/common/date-picker';

class ModalEditCattrsTest extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      dateStr: null,
      pending: false,
      cattrs: {},
    };

    this.onChangeTestDate = this.onChangeTestDate.bind(this);
  }

  get showValues() {
    if (this.state.pending) return false;
    if (!this.state.dateStr) return false;
    return true;
  }

  onChangeTestDate(dateStr) {
    const {company, employee} = this.props;
    this.setState({dateStr, pending: true});
    CadminApi.employeesCattrsGet(company.id, employee.id, dateStr).then(({cattrs}) => {
      this.setState({cattrs: cattrs, pending: false});
    }).catch((error) => {
      this.setState({cattrs: {}, pending: false});
    });
  }

  render() {
    const {pending, cattrs} = this.state;

    return (<>
      <p>Select a date to see the employee's attributes as of that date.</p>

      <h3 className="bform-h3">As Of</h3>
      <DatePicker onChange={this.onChangeTestDate} dateStr={this.state.dateStr} />

      <h3 className="bform-h3">Values</h3>
      <table className="attrs"><tbody>
        {this.props.companyCattrs.map((cattr) => {
          const optionId = cattrs[cattr.id];
          const option = cattr.options.find(o => o.id === optionId);
          const optionLabel = option?.name || '[No Value]';
          return (
            <tr key={cattr.id}>
              <th>{cattr.name}</th>
              <td>{this.showValues ? optionLabel : '-'}</td>
            </tr>
          );
        })}
      </tbody></table>
    </>);
  }

}

ModalEditCattrsTest.propTypes = {
  company: PropTypes.object.isRequired,
  employee: PropTypes.object.isRequired,
  companyCattrs: PropTypes.arrayOf(PropTypes.object).isRequired,
};
ModalEditCattrsTest.defaultProps = {};

export default ModalEditCattrsTest;
